export default __webpack_public_path__ + "static/media/promotion2.6703f627.png";